var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPlaceholderImageOther = function SvgPlaceholderImageOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#placeholderImageOther_svg__clip0_7683_98273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.302 7.156V5.49C9.302 2.927 11.63.85 14.5.85c2.87 0 5.198 2.077 5.198 4.64v1.666",
    stroke: "#840000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.068 8.85c0-1.248-.985-2.259-2.197-2.259H14.5v25.412h12.12c1.211 0 2.196-1.01 2.196-2.259L26.07 8.85h-.002z",
    fill: "#840000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.126 6.591c-1.212 0-2.196 1.01-2.196 2.259L.184 29.744c0 1.248.985 2.259 2.197 2.259H14.5V6.59H5.126z",
    fill: "#C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3 12.8c1.6 0 3.134.643 4.268 1.799a6.277 6.277 0 011.781 4.366c0 .814-.154 1.62-.456 2.373a6.17 6.17 0 01-1.309 2.014 6.05 6.05 0 01-1.959 1.347 5.88 5.88 0 01-2.312.473 5.982 5.982 0 01-2.309-.46 5.974 5.974 0 01-1.959-1.335 6.192 6.192 0 01-1.313-2.002 6.278 6.278 0 01-.464-2.369c0-.814.155-1.624.457-2.377a6.19 6.19 0 011.308-2.014 5.99 5.99 0 011.964-1.343 5.895 5.895 0 012.316-.468H14.3V12.8zm0 2.055c-.527 0-1.05.11-1.538.317a4.012 4.012 0 00-1.3.896 4.135 4.135 0 00-.87 1.339 4.217 4.217 0 00.005 3.158c.202.5.5.952.872 1.334.373.383.817.684 1.305.892a3.931 3.931 0 001.539.313c1.067 0 2.09-.444 2.843-1.22a4.177 4.177 0 001.17-2.927 4.177 4.177 0 00-1.19-2.918 3.965 3.965 0 00-2.851-1.2l.012.012.004.004zm0 2.002c.27 0 .54.053.794.159.25.106.48.26.67.456a2.141 2.141 0 01.611 1.497c0 .277-.051.554-.155.814a2.12 2.12 0 01-.444.688 2.032 2.032 0 01-1.46.627 2.045 2.045 0 01-1.463-.623 2.147 2.147 0 01-.607-1.502c0-.565.219-1.102.607-1.501a2.039 2.039 0 011.464-.623h-.012l-.004.008z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "placeholderImageOther_svg__clip0_7683_98273"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.184)",
    d: "M0 0h28.632v32H0z"
  })))));
};
export default SvgPlaceholderImageOther;